import translationEN from './en';
import translationNL from './nl';

const languages = {
  en: translationEN,
  nl: translationNL,
};

export default languages;
